import forEach from 'lodash/forEach';
import sanitizer from 'sanitizer';

const queryUtil = {
  sanitize(obj = {}) {
    let newQueryObj = {};

    for (var key in obj) {
      if (obj.hasOwnProperty(key) && obj[key]) {
        const queryValue = obj[key];

        newQueryObj[encodeURIComponent(key)] = encodeURIComponent(sanitizer.sanitize(queryValue));
      }
    }

    return newQueryObj;
  },
  stringify(obj) {
    var str = [];

    forEach(obj, (v, k) => {
      if (v || v === false) {
        str.push(encodeURIComponent(k) + '=' + encodeURIComponent(v));
      }
    });

    if (str.length > 0) {
      return str.join('&');
    } else {
      return '';
    }
  },
  parse(string) {
    if (!string) {
      return string;
    }
    const sanitizedString = string.replace('?', '');
    var queryObj = {};
    var pieces = sanitizedString.split('&');
    pieces.forEach(function (piece) {
      var splitPiece = piece.split('=');
      var name = splitPiece[0];
      var value = splitPiece[1];
      queryObj[name] = value;
    });

    return queryObj;
  },
  safeJsonStringify(obj) {
    return JSON.stringify(obj)
      .replace(/<\/script/g, '<\\/script')
      .replace(/<!--/g, '<\\!--');
  },
  removeQueryParameters(path) {
    if (!path) {
      return path;
    }
    return path.split('?')[0];
  },
};

export default queryUtil;
